import React, { forwardRef } from 'react';
import classNames from 'classnames';
import Typography from '@mui/material/Typography';
import styles from './Section.module.css';

interface ISection {
  title?: string;
  children: React.ReactNode;
  maxWidth?: 'xl' | 'md' | 'sm' | 'xs' | 'lg' | false;
  titleCenter?: boolean;
  width?: string;
  className?: string;
  classContainer?: string;
  wrapper?: boolean;
  section?: boolean;
  ref?: any;
  mobileNoGap?: boolean;
}

const Section = forwardRef(
  ({ title, wrapper, children, className, titleCenter = true, classContainer, mobileNoGap }: ISection, ref: any) => {
    const topMargin = classNames({
      [styles.margin]: wrapper,
    });
    return (
      <div className={classNames(styles.container, topMargin, className)} ref={ref}>
        {title && (
          <Typography
            variant={'h1'}
            className={styles.title}
            style={{
              textAlign: `${titleCenter ? 'center' : 'left'}`,
            }}
          >
            {' '}
            {title}
          </Typography>
        )}
        <div className={classNames(mobileNoGap ? styles.sectionContentNoGap : styles.sectionContent, classContainer)}>
          {children}
        </div>
      </div>
    );
  }
);

export default Section;
